import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var QuotationsListComponent = /** @class */ (function () {
    function QuotationsListComponent(router, globalDataService, requestV2Service) {
        var _this = this;
        this.router = router;
        this.globalDataService = globalDataService;
        this.requestV2Service = requestV2Service;
        this.customQuotations = [];
        this.inited = false;
        this.isLoaded = false;
        this.quotations = [];
        this.filteredQuotations = [];
        this.globalDataService.getCurrentProject().subscribe(function (project) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var quotationResults, versionsResults, _loop_1, this_1, i;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!project)
                            return [2 /*return*/];
                        if (!!this.inited) return [3 /*break*/, 7];
                        this.inited = true;
                        this.currentProject = project;
                        return [4 /*yield*/, this.requestV2Service.getQuotations(project.id)];
                    case 1:
                        quotationResults = _a.sent();
                        this.quotations = quotationResults.items;
                        return [4 /*yield*/, this.requestV2Service.getVersions(this.quotations.map(function (i) { return i.id; }).join(','), {})];
                    case 2:
                        versionsResults = _a.sent();
                        _loop_1 = function (i) {
                            var quotation, versions, versions_1, versions_1_1, version, financial, e_1_1;
                            var e_1, _a;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        quotation = this_1.quotations[i];
                                        versions = versionsResults.items.filter(function (i) { return i.id_quotation === quotation.id; });
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 6, 7, 8]);
                                        versions_1 = (e_1 = void 0, tslib_1.__values(versions)), versions_1_1 = versions_1.next();
                                        _b.label = 2;
                                    case 2:
                                        if (!!versions_1_1.done) return [3 /*break*/, 5];
                                        version = versions_1_1.value;
                                        return [4 /*yield*/, this_1.requestV2Service.getQuotationVersionFinancial(version.id)];
                                    case 3:
                                        financial = _b.sent();
                                        if (version._related && version._related._quotation_variant) {
                                            version.title = version.title + " - " + version._related._quotation_variant.name;
                                        }
                                        this_1.customQuotations.push(tslib_1.__assign({ financial: financial,
                                            version: version }, quotation));
                                        _b.label = 4;
                                    case 4:
                                        versions_1_1 = versions_1.next();
                                        return [3 /*break*/, 2];
                                    case 5: return [3 /*break*/, 8];
                                    case 6:
                                        e_1_1 = _b.sent();
                                        e_1 = { error: e_1_1 };
                                        return [3 /*break*/, 8];
                                    case 7:
                                        try {
                                            if (versions_1_1 && !versions_1_1.done && (_a = versions_1.return)) _a.call(versions_1);
                                        }
                                        finally { if (e_1) throw e_1.error; }
                                        return [7 /*endfinally*/];
                                    case 8: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        i = 0;
                        _a.label = 3;
                    case 3:
                        if (!(i < this.quotations.length)) return [3 /*break*/, 6];
                        return [5 /*yield**/, _loop_1(i)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        i = i + 1;
                        return [3 /*break*/, 3];
                    case 6:
                        this.resetQuotations();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        }); });
    }
    QuotationsListComponent.prototype.resetQuotations = function () {
        var _this = this;
        this.filteredQuotations = [];
        this.customQuotations.forEach(function (quotation) {
            var quotationCopy = tslib_1.__assign({}, quotation);
            _this.filteredQuotations.push(quotationCopy);
        });
        this.isLoaded = true;
    };
    QuotationsListComponent.prototype.filter = function (text) {
        var _this = this;
        if (!text || text.length <= 0) {
            this.resetQuotations();
            return;
        }
        this.filteredQuotations = [];
        this.quotations.forEach(function (quotation) {
            if (quotation.title.toLowerCase().includes(text.toLowerCase())) {
                _this.filteredQuotations.push(quotation);
            }
        });
    };
    QuotationsListComponent.prototype.searchEvent = function (event) {
        this.filter(event.target.value);
    };
    QuotationsListComponent.prototype.isEmpty = function () {
        return !this.filteredQuotations || this.filteredQuotations.length <= 0;
    };
    QuotationsListComponent.prototype.openQuotation = function (quotation) {
        // tslint:disable-next-line:max-line-length
        return environment.customer_url + "/quotations/" + quotation.id + "/versions/" + quotation.version.id;
    };
    QuotationsListComponent.prototype.calculateTTC = function (quotation) {
        var vat = Object.keys(quotation.financial.customer.vat)
            .reduce(function (acc, item) {
            return acc + quotation.financial.customer.vat[item];
        }, 0);
        return quotation.financial.customer.total + vat;
    };
    return QuotationsListComponent;
}());
export { QuotationsListComponent };
